export default __webpack_public_path__ + "static/media/D01_s.744ab353.png";